import { render, staticRenderFns } from "./OfertasHome.vue?vue&type=template&id=1cd5f115&scoped=true&lang=pug"
import script from "./OfertasHome.vue?vue&type=script&lang=js"
export * from "./OfertasHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5f115",
  null
  
)

export default component.exports